import React, { useLayoutEffect, useRef } from 'react';
import styled from 'styled-components';
import { gsap } from 'gsap';

const Wrapper = styled.footer`
  margin-top: 40px;
  border-top: 1px solid var(--border);
  background: var(--bg);
`;

const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 18px 20px;
  color: var(--muted);
  font-size: 0.95rem;
`;

const Footer = () => {
  const year = new Date().getFullYear();
  const ref = useRef(null);
  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      if (ref.current) gsap.from(ref.current, { autoAlpha: 0, y: 12, duration: 1, ease: 'power2.out' });
    });
    return () => ctx.revert();
  }, []);
  return (
    <Wrapper ref={ref}>
      <Inner>
        © {year} Lamar's Clothes · All Rights Reserved · Built by Bobs Smart Tech Solutions ·{' '}
        <a href="https://bobssmarttechsolutions.com" target="_blank" rel="noreferrer">Get a site like this</a>
      </Inner>
    </Wrapper>
  );
};

export default Footer;
